import client from '@stores/apollo'
import gql from 'graphql-tag'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  cancelEmployeeImport: {
    employee_import: { id: string; status: string }
  }
}

const mutateHandler = handleFetchResult<IPayload, { id: string; status: string }>({
  handler: (data) => data.cancelEmployeeImport.employee_import,
  name: 'cancelEmployeeImport',
})

export default function cancelEmployeeImport(
  employeeImportId: string
): Promise<{ id: string; status: string }> {
  return client.gql
    .mutate({ mutation, variables: { input: { employeeImportId } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation cancelEmployeeImport($input: CancelEmployeeImportInput!) {
    cancelEmployeeImport(input: $input) {
      employee_import {
        id
        status
      }
    }
  }
`
